// extracted by mini-css-extract-plugin
export default {"root":"DeleteConfigModal_root__APcBN","container":"DeleteConfigModal_container__McZDm"};